import React from 'react';
import './Layout.css';

// Page shell only. The site header is rendered once globally in App.js (SiteHeader),
// so Layout must not render its own — doing so stacked a second header on pages that
// wrap their content in it (listing/order detail).
const Layout = ({ children }) => {
    return (
        <div>
            <main className="gh-layout-main">{children}</main>
        </div>
    );
};

export default Layout;
